export default defineNuxtRouteMiddleware((to, from) => {
  // Suppress errors in production
  if (process.env.NODE_ENV === 'production') {
    // Catch and suppress console errors
    const originalConsoleError = console.error
    const originalConsoleWarn = console.warn
    
    console.error = (...args: any[]) => {
      // Only log critical errors in production
      if (args[0] && typeof args[0] === 'string' && args[0].includes('Critical')) {
        originalConsoleError(...args)
      }
    }
    
    console.warn = (...args: any[]) => {
      // Suppress warnings in production
      return
    }
    
    // Restore original console methods after a delay
    setTimeout(() => {
      console.error = originalConsoleError
      console.warn = originalConsoleWarn
    }, 1000)
  }
}) 